/* eslint-disable react/button-has-type, react/jsx-props-no-spreading  */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from './Button';
import MediumWithBorder from '../icons/button/MediumWithBorder';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/buttons/empty.scss';

const propTypes = {
    color: AppPropTypes.color,
    theme: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: null,
    theme: null,
    className: null,
};

const EmptyButton = ({ color, theme, className, ...props }) => {
    return (
        <Button
            backgrounds={[MediumWithBorder]}
            invertedColor={color}
            color={color}
            centered
            {...props}
            className={classNames([
                styles.container,
                {
                    [styles.dark]: theme === 'dark',
                    [styles.light]: theme !== 'dark',
                    [className]: className !== null,
                },
            ])}
        />
    );
};

EmptyButton.propTypes = propTypes;
EmptyButton.defaultProps = defaultProps;

export default EmptyButton;
